//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { api_GetMetalList, api_ChangeMetal, api_UnassignMetal } from "../../../api";
import { conversion } from "../../../tool";

export default {
  data() {
    return {
      metals: [],
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    async getMetalList() {
      try {
        const res = await api_GetMetalList();
        this.metals = res.data.data;
      } catch (error) {
        console.error("获取金属列表失败:", error);
      }
    },
    async onChangeMetal(item) {
      if (this.user.currMetalUrl === item.icon) {
        const res = await api_UnassignMetal({
            val: item.id
        });
        if (res.data.code === 0) {
            this.$message.success("卸下勋章成功");
            this.$store.commit("setInfo");
        } else {
            this.$message.error(res.data.msg || "卸下勋章失败");
        }
      } else {
        try {
            const res = await api_ChangeMetal({
                val: item.id
            });
            if (res.data.code === 0) {
                this.$message.success("装备勋章成功");
                this.$store.commit("setInfo");
            } else {
                this.$message.error(res.data.msg || "装备勋章失败");
            }
        } catch (error) {
            console.error("装备勋章失败:", error);
            this.$message.error("装备勋章失败，请稍后再试");
        }
      }
    },
  },
  filters: {
    conversion,
    add(v) {
      return v > 0 ? `+${v}` : v;
    }
  },
  created() {
    this.getMetalList();
  },
  name: "badgeList",
};
